module.exports = __webpack_public_path__ + "img/email_icon.04a595d2.svg";